
export const baseURL = {
    // live: '/api/proxy/',
    // development: '/api/proxy/',
    live: 'https://devapi.infoxsystem.com/api/',
    development: 'https://devapi.infoxsystem.com/api/',
    local: '/api/proxy/',
    //dashboardapi: https://devapipy.infoxsystem.com/api
    dashboardApi: 'https://devapipy.infoxsystem.com/api/pyproxy',
    AiBaseURL: 'https://devapipy.infoxsystem.com',
    // Python backend — client API error logs (POST/GET, no local files)

    // dashboardApi: 'http://localhost:8000/api/pyproxy',
    // AiBaseURL: 'http://localhost:8000'
};
